import { Link } from 'react-router';

const VERSION = (import.meta.env.VITE_APP_VERSION as string | undefined) ?? 'dev';

/** Legacy layout_footer(): version, copyright, "Powered by", plus the help links. */
export function AppFooter() {
  return (
    <footer className="border-t border-border bg-surface-muted px-3 py-3 text-xs text-ink-muted sm:px-5">
      <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
        <p>
          MantisBT Next {VERSION} · Copyright © 2000–{new Date().getFullYear()} MantisBT Team
        </p>
        <nav aria-label="Footer">
          <ul className="flex flex-wrap gap-x-4 gap-y-1">
            <li>
              <Link to="/account/preferences">Preferences</Link>
            </li>
            <li>
              <a href="/api/docs">API documentation</a>
            </li>
            <li>
              <a href="https://mantisbt.org/" rel="noopener noreferrer">
                Powered by MantisBT
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}
